export type FeatureFlag = {
	id: number;
	description?: string;
	name: string;
};

// map so we can ensure only get correct Features
export const enum FeatureFlagType {
	ENABLE_RFX_FUNCTIONALITY = 1,
	TEST_ACCOUNT = 2,
	TERMS_AND_CONDITIONS = 3,
	ENABLE_NEW_SUBMISSION_PDF = 4,
	ENABLE_DASHBOARD = 5,
	ENABLE_PRE_APPROVAL_FLOW = 6,
	RESTRICT_RFX_SUBMISSION_VIEW = 10,
	ENABLE_ONBOARDING = 11,
	ENABLE_CLARIFICATIONS = 12,
	ENABLE_AI = 13,
	ENABLE_AI_EVALUATION = 14,
	ENABLE_RFX_EVALUATION = 15,
	ENABLE_PERFORMANCE_MANAGEMENT = 16,
	ENABLE_NEW_SHORTLIST_REPORT = 17,
	CUSTOMISE_SHORTLIST_REPORT = 18,
}
